import { css } from 'styled-components';
import { SIDEBAR_MOBILE_BREAKPOINT } from '@constants/sidebar';

export const flexCenterVertical = css`
  display: flex;
  align-items: center;
`;

export const flexCenter = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const flexColumn = css`
  display: flex;
  flex-direction: column;
`;

export const flexColumnCenter = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const hideScrollbar = css`
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const heroTitle = css`
  font-weight: 500;

  ${({ theme: { font } }) => css`
    font-size: ${font.headlineLarge.fontSize};
    line-height: ${font.headlineLarge.lineHeight};

    @media (max-width: ${SIDEBAR_MOBILE_BREAKPOINT}px) {
      font-size: ${font.headlineMedium.fontSize};
      line-height: ${font.headlineMedium.lineHeight};
    }
  `}
`;

export const when = (
  condition: boolean,
  style: ReturnType<typeof css> | string,
  fallback?: ReturnType<typeof css> | string,
) => (condition ? style : fallback || '');

export const setApplicationScrollable = (scrollable: boolean): void => {
  const appContainer = document.getElementById('ai-sync');

  if (!appContainer) return;

  if (scrollable) {
    appContainer.style.overflow = '';

    return;
  }

  appContainer.style.overflow = 'hidden';
};

interface RgbColor {
  r: number;
  g: number;
  b: number;
}

/**
 * Converts a hex colour to its RGB (0-255) equivalent
 */
export const hexToRgb = (hex: string): RgbColor => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) throw new Error(`Invalid hex colour: ${hex}`);
  return {
    r: Number.parseInt(result[1], 16),
    g: Number.parseInt(result[2], 16),
    b: Number.parseInt(result[3], 16),
  };
};

/**
 * Converts a hex colour to its normalised RGB (0-1) equivalent
 */
export const hexToRgbNormalised = (hex: string): RgbColor => {
  const rgb = hexToRgb(hex);
  return {
    r: rgb.r / 255,
    g: rgb.g / 255,
    b: rgb.b / 255,
  };
};
